module.exports = __webpack_public_path__ + "static/desktop/img/design-tablet-diarybook.519e9e18.png";